import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import {
  Container,
  ContainerItems,
  Message,
  Loader,
} from './styles';

import TotalSuccess from './total-success';
import Directness from './directness';
import Tasks from './tasks';

import { GET_ANALYTICS_TREE_TEST } from '../../graphql';

const OverviewComponent = (props) => {
  const { projectId, segmentId } = props;

  const {
    loading,
    data = {},
    errors,
  } = useQuery(GET_ANALYTICS_TREE_TEST, {
    variables: {
      projectId,
      segmentId,
    },
    fetchPolicy: 'no-cache',
  });

  const { treeTestResults = {} } = data?.analytics || {};

  const {
    totalSuccess: totaSucessPercentage,
    directness: directPercentage,
    tasks,
  } = treeTestResults;

  if (loading) {
    return <Loader data-loader="overview-loader" />;
  }

  if (errors) {
    return (
      <Message>
        Error while fetching analytics.
      </Message>
    );
  }

  return (
    <Container>

      <ContainerItems>
        <TotalSuccess
          percentage={totaSucessPercentage}
        />
        <Directness
          percentage={directPercentage}
        />
      </ContainerItems>

      <ContainerItems>
        <Tasks
          tasks={tasks}
        />
      </ContainerItems>

    </Container>
  );
};

OverviewComponent.propTypes = {
  projectId: PropTypes.string.isRequired,
  segmentId: PropTypes.string,
};

OverviewComponent.defaultProps = {
  segmentId: undefined,
};

export default OverviewComponent;
